import { useMemo } from 'react'
import { getStateByAbbreviation } from '../../../../../utils/common'
import { EMPTY_TEXT_NA } from '../../../../../utils/constants'
import { text } from '../../constants'
import { LicenseInfoRow } from '../LicenseInfoRow/LicenseInfoRow'
import './licenseInfoCardStyles.scss'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getVisitTypesValue = (visitTypesList) => {
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  return visitTypesList.map(({ Name }) => Name).join(', ')
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const LicenseInfoCard = ({ licenseInfo }) => {
  const { LicensedBy, Number, StateCode, VisitTypes } = licenseInfo

  const licenseInfoRowsConfig = useMemo(
    () => [
      {
        name: text.LICENSE_NO,
        value: Number,
      },
      {
        name: text.LICENSED_BY,
        value: LicensedBy,
      },
      {
        name: text.VISIT_TYPES,
        value: getVisitTypesValue(VisitTypes),
      },
    ],
    [LicensedBy, Number, VisitTypes],
  )

  return (
    <div className='license-info-card-main-wrapper'>
      <div className='license-info-card-title'>{getStateByAbbreviation(StateCode) + StateCode || EMPTY_TEXT_NA}</div>
      {licenseInfoRowsConfig.map(({ name, value }) => (
        <LicenseInfoRow name={name} value={value} />
      ))}
    </div>
  )
}
